import { Link } from '@/components/Link'
import { Icon, IconName } from '@/components/Icon'

const sampleIcon: IconName = 'Sparkle'

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-16/24 spaces:font-semi spaces:text-content-1 spaces:border-b spaces:border-canvas-3 spaces:pb-8'>
				{title}
			</h3>
			{children}
		</div>
	)
}

export function LinkSandbox () {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── Icon variants ── */}
			<Section title='Icon Variants'>
				<div className='spaces:flex spaces:flex-col spaces:gap-12'>
					<div className='spaces:flex spaces:items-center spaces:gap-16'>
						<span className='spaces:w-80 spaces:text-12/24 spaces:text-content-3 spaces:font-default spaces:shrink-0'>
							no icon
						</span>
						<Link label='Example link' href='#' />
					</div>
					<div className='spaces:flex spaces:items-center spaces:gap-16'>
						<span className='spaces:w-80 spaces:text-12/24 spaces:text-content-3 spaces:font-default spaces:shrink-0'>
							icon left
						</span>
						<Link
							label='Example link'
							iconLeft={<Icon name={sampleIcon} size={16} />}
							href='#'
						/>
					</div>
					<div className='spaces:flex spaces:items-center spaces:gap-16'>
						<span className='spaces:w-80 spaces:text-12/24 spaces:text-content-3 spaces:font-default spaces:shrink-0'>
							icon right
						</span>
						<Link
							label='Example link'
							iconRight={<Icon name={sampleIcon} size={16} />}
							href='#'
						/>
					</div>
					<div className='spaces:flex spaces:items-center spaces:gap-16'>
						<span className='spaces:w-80 spaces:text-12/24 spaces:text-content-3 spaces:font-default spaces:shrink-0'>
							both icons
						</span>
						<Link
							label='Example link'
							iconLeft={<Icon name={sampleIcon} size={16} />}
							iconRight={<Icon name={sampleIcon} size={16} />}
							href='#'
						/>
					</div>
				</div>
			</Section>

			{/* ── Underline variants ── */}
			<Section title='Underline Variants'>
				<div className='spaces:flex spaces:flex-col spaces:gap-12'>
					<div className='spaces:flex spaces:items-center spaces:gap-16'>
						<span className='spaces:w-120 spaces:text-12/24 spaces:text-content-3 spaces:font-default spaces:shrink-0'>
							default (true)
						</span>
						<Link label='Example link' href='#' defaultUnderline={true} />
					</div>
					<div className='spaces:flex spaces:items-center spaces:gap-16'>
						<span className='spaces:w-120 spaces:text-12/24 spaces:text-content-3 spaces:font-default spaces:shrink-0'>
							hover only (false)
						</span>
						<Link label='Example link' href='#' defaultUnderline={false} />
					</div>
				</div>
			</Section>
		</div>
	)
}
